@if (listOfObjects) {
  @for (element of elements; track element) {
    <mat-card>
      <mat-card-title>{{ element.name }}</mat-card-title>
      <mat-card-content>
        <div class="space-between">{{ element.type }}</div>
        <div class="space-between">{{ element.createAt | date: 'shortDate' }}</div>
      </mat-card-content>
      <mat-divider></mat-divider>
    </mat-card>
  }
} @else {
  @for (element of elements; track element) {
    <mat-card>
      {{ element }}
    </mat-card>
  }
}
